import React from 'react'
import './App.scss'
import MainLayout from './components/mainLayout/MainLayout'
import { BrowserRouter } from 'react-router-dom'
import Routes from './routes/Routes'
import AuthProvider from './pages/Auth/AuthProvider'

function App() {
  return (
    <BrowserRouter>
      <MainLayout>
        {/* Unfortunately, this appears to be a known bug with <Authenticator.Provider> and <Authenticator/>.*/}
        {/* Until the bug is fixed, this is work around*/}
        {/* <Authenticator className='hidden-authenticator'></Authenticator> */}
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </MainLayout>
    </BrowserRouter>
  )
}

export default App
